import { useEffect, useRef } from 'react';

/** Hold previous rendered `value`; it's a `ref` that changes after [value -> render]
 *
 * Usage e.g. run effect when 1 dependency changed
 */
export const usePrev = <T>(value: T): T | undefined => {
  const valueRef = useRef<T>();

  useEffect(() => {
    valueRef.current = value;
  }, [value]);

  return valueRef.current;
};
